export const isValidTapp = (tapp) => {
    return !!(tapp.id && tapp.source);
}
